import { useEffect, useState } from 'react';
import { Typography, Modal } from 'antd';
import AntDButton from '../Button';
import ResourceSearchableDropdown from '../ResourceSearch';
import en from 'src/messages/en.json';

const UserListModal = ({
  show,
  onHide,
  onConfirm,
  handleSelect,
  selectedUser,
}) => {
  const [selectedReportee, setSelectedReportee] = useState<any>();
  const { Title } = Typography;

  const onSelectedResourceChange = (selected) => {
    if (selected) {
      setSelectedReportee({ name: selected.label, email: selected.value });
      handleSelect(selected.value);
    } else {
      setSelectedReportee(null);
      handleSelect(null);
    }
  };

  useEffect(() => {
    if (!show) {
      setSelectedReportee(null);
      handleSelect(null);
    }
  }, [show, handleSelect]);

  return (
    <Modal
      open={show}
      onCancel={onHide}
      centered
      maskClosable={false}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <Title level={4} style={{ margin: 0 }}>
            {en.Access.Title.grant}
          </Title>
        </div>
      }
      footer={
        <div style={{ padding: '1rem' }}>
          <AntDButton
            type="primary"
            onClick={onConfirm}
            statusOnComplete=" Grant Access"
            htmlType="button"
          />
        </div>
      }
    >
      <div style={{ padding: '0 1rem' }}>
        <ResourceSearchableDropdown
          selected={
            selectedReportee
              ? { label: selectedReportee.name, value: selectedReportee.email }
              : null
          }
          onChange={onSelectedResourceChange}
          condition={true}
          placeholder={en.Common.Placeholder.selectResource}
          internalResourceFlag={true}
        />
      </div>
    </Modal>
  );
};

export default UserListModal;
